var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.length)?_c('ImageText',{staticClass:"additional-info",attrs:{"value":_vm.value,"theme":"sections","caption-placement":"outside"},scopedSlots:_vm._u([{key:"content",fn:function({ description }){return [_c('div',{staticClass:"additional-info__description",domProps:{"innerHTML":_vm._s(description)}})]}}],null,false,220588006)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }